import { privateAxios, publicAxios } from "../lib/api";
import { ICatalogResponse, IVerifyCatalogPINResponse } from "../types/catalog";
import { ApiConstants } from "../utils/constants";

export class SupplierService {
  static async getAllCatalogs({
    businessId,
    sellerId = null,
    catalogType = "PUBLIC",
    paging = true,
    limit = 50,
    offset = 0,
    searchTerm,
  }: {
    businessId: string;
    sellerId?: string | null;
    catalogType?: string;
    paging: boolean;
    limit: number;
    offset: number;
    searchTerm?: string;
  }): Promise<ICatalogResponse> {
    const response = await privateAxios.get(
      `${ApiConstants.catalogURL}/suppliers`,
      {
        params: {
          businessId,
          sellerId,
          catalogType,
          paging,
          limit,
          offset,
          searchTerm,
        },
      }
    );

    return response.data as ICatalogResponse;
  }

  /**
   * verify user can access a catalog
   * @param catalogId
   * @param businessId,
   * @param accountId,
   * @param pin
   * @returns
   */
  static async verifyAccess({
    catalogId,
    businessId,
    accountId,
    pin,
  }: {
    catalogId: string;
    businessId: string | null;
    accountId: string | null;
    pin?: string;
  }): Promise<IVerifyCatalogPINResponse> {
    pin = pin ? `&pin=${pin}` : "";
    const response = await publicAxios.get(
      `${ApiConstants.catalogURL}/verify?catalogId=${catalogId}&businessId=${businessId}&accountId=${accountId}${pin}`
    );
    return response.data;
  }
}
